import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Heart, Plus, LogIn, UserPlus, PencilLine } from 'lucide-react';
import jewmapLogo from '@/assets/jewmap-logo.png';

interface AuthPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: 'favorites' | 'add' | 'edit';
}

export const AuthPromptModal = ({ isOpen, onClose, action }: AuthPromptModalProps) => {
  const navigate = useNavigate();

  const config = {
    favorites: {
      icon: <Heart className="w-8 h-8 text-destructive" />,
      title: 'Sauvegardez vos favoris',
      description: 'Connectez-vous pour sauvegarder vos lieux préférés et y accéder depuis n\'importe où.',
    },
    add: {
      icon: <Plus className="w-8 h-8 text-primary" />,
      title: 'Ajoutez un lieu',
      description: 'Connectez-vous pour ajouter un nouveau lieu à JewMap. Notre équipe le vérifiera avant publication.',
    },
    edit: {
      icon: <PencilLine className="w-8 h-8 text-primary" />,
      title: 'Suggérer une modification',
      description: 'Connectez-vous pour suggérer une modification de ce lieu. Notre équipe la vérifiera.',
    },
  };

  const currentConfig = config[action];

  const handleNavigate = (tab: 'login' | 'signup') => {
    onClose();
    const fromPath = action === 'favorites' ? '/favorites' : action === 'add' ? '/add-place' : '/';
    navigate('/auth', { state: { from: fromPath } });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="flex flex-col items-center mb-4">
            <img src={jewmapLogo} alt="JewMap" width={48} height={48} className="w-12 h-12 mb-3" />
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
              {currentConfig.icon}
            </div>
          </div>
          <DialogTitle className="text-xl">{currentConfig.title}</DialogTitle>
          <DialogDescription className="text-center">
            {currentConfig.description}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 mt-4">
          <Button 
            onClick={() => handleNavigate('login')}
            className="w-full gradient-primary text-primary-foreground"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Se connecter
          </Button>
          <Button 
            variant="outline"
            onClick={() => handleNavigate('signup')}
            className="w-full"
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Créer un compte
          </Button>
          <Button 
            variant="ghost"
            onClick={onClose}
            className="w-full text-muted-foreground"
          >
            Plus tard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
